<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="changeTab(0)">
          待签约
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="changeTab(1)">
          已签约
        </li>
      </ul>
    </div>

    <div class="member-main-body">
      <div
        class="no-data"
        v-show="notAgreementList.length == 0 && tabIndex === 0"
      >
        <img src="../../assets/images/v3/no-data.png" />
        <p>您还没有待签约协议</p>
      </div>
      <div class="no-data" v-show="agreementList.length == 0 && tabIndex === 1">
        <img src="../../assets/images/v3/no-data.png" />
        <p>您还没有已签约协议</p>
      </div>
      <ul class="order-list">
        <li
          v-for="(item, index) in tabIndex === 0
            ? notAgreementList
            : agreementList"
          :key="index"
        >
          <!-- <div class="order-no">订单号：{{ item.orderNo }}</div> -->
          <div class="order-item">
            <!-- <Avatar
              shape="square"
              size="large"
              :src="tabIndex === 0 ? item.imgList[0] : item.signimg"
            /> -->
            <img
              :src="tabIndex === 0 ? item.imgList[0] : item.signimg"
              alt=""
              style="width: 80px; height: 80px"
            />
            <div class="order-info">
              <div class="name">
                <div>
                  协议名称：{{ tabIndex === 0 ? item.title : item.agreementName }}
                </div>
                <div v-if="tabIndex === 1">签约时间：{{ item.createdate }}</div>
                <span>
                  <Tag v-if="tabIndex === 0" color="default">待签约</Tag>
                  <template v-if="tabIndex === 1">
                    <Tag v-if="item.status == 1" color="success">已签约</Tag>
                    <Tag v-else-if="item.status == 0" color="red">待审核</Tag>
                    <Tag v-else-if="item.status == -1" color="default"
                      >已销毁</Tag
                    ></template
                  >
                </span>
              </div>
            </div>
            <div class="order-action">
              <!-- <Button
                v-if="tabIndex === 0"
                type="default"
                size="large"
                shape="circle"
                style="height: 32px; border-radius: 32px; font-size: 14px"
                long
              >
                待签约
              </Button> -->
              <div v-if="tabIndex === 1">
                <Button
                  type="primary"
                  size="large"
                  shape="circle"
                  style="height: 32px; border-radius: 32px; font-size: 14px"
                  long
                  @click="checkSigning(item)"
                >
                  查看
                </Button>
              </div>
              <div v-else>
                <Button
                  type="warning"
                  size="large"
                  shape="circle"
                  style="height: 32px; border-radius: 32px; font-size: 14px"
                  long
                  @click="signing(item)"
                >
                  立即签约
                </Button>
                <!-- <Dropdown trigger="click" style="width: 100px;">

                  <Dropdown-menu slot="list">
                    <div
                      class="pay-list"
                      v-for="(pay, index) in paymentList"
                      :key="index"
                    >
                      <a @click="toPayment(pay, item)" href="javascript:;">
                        {{ pay.name }}
                      </a>
                    </div>
                  </Dropdown-menu>
                </Dropdown> -->
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <Modal
      :title="null"
      v-model="isShowSigningCode"
      ok-text="我已签约完成"
      cancel-text=""
      width="320"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-ok="confirmSigning"
    >
      <div class="code">
        <vue-qr
          :margin="5"
          :size="180"
          :correctLevel="3"
          :text="qrcodeData.url"
          :logoSrc="qrcodeData.icon"
          :logoMargin="5"
          style="display: block; margin: 24px auto"
        ></vue-qr>
      </div>
      <div class="tips" style="text-align: center; color: #258aff">
        请扫码完成签约
      </div>
    </Modal>

    <Modal
      :title="null"
      v-model="isShowSigningDetail"
      width="480"
      :footer-hide="true"
      class-name="vertical-center-modal"
    >
      <div
        style="
          position: relative;
          padding: 24px;
          height: 80vh;
          overflow-y: scroll;
        "
      >
        <img :src="imgBase64" width="100%" />
        <div style="position: absolute; top: 0; left: 0">
          <Tag v-if="signingDetail.status == 1" color="success">已签约</Tag>
          <Tag v-else-if="signingDetail.status == 0" color="red">待审核</Tag>
          <Tag v-else-if="signingDetail.status == -1" color="default"
            >已销毁</Tag
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user, order } from "../../request";
import { getToken } from "../../utils/localStorage";
import VueQr from "vue-qr";
export default {
  mixins: [siteMixin],
  components: {
    VueQr,
  },
  data() {
    return {
      tabIndex: 0,
      agreementList: [],
      notAgreementList: [],
      materialDataList: [],
      sendStatus: 0,
      isShowSigningCode: false,
      isShowSigningDetail: false,
      // oemBaseUrl: "http://oem.beegoedu.com/",
      signingDetail: {},
      qrcodeData: {
        url: "",
        icon: "",
      },
      imgBase64: '',
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      user.getAgreement(this.loginUser.userId).then((res) => {
        if (res.status == 1) {
          this.agreementList = res.data;
        }
      });
      user.getNotAgreement(this.loginUser.userId).then((res) => {
        if (res.status == 1) {
          this.notAgreementList = res.data;
        }
      });
    },

    changeTab(index) {
      if (this.tabIndex == index) return false;
      this.tabIndex = index;
    },
    // 签约
    signing(item) {
      const authToken = getToken();
      this.agreementObj = item;
      this.qrcodeData.url = `http://${this.siteConfig.mdomain}/me/signingDetail?id=${item.id}&orderId=${item.orderId}&source=pc&userId=${this.loginUser.userId}&token=${authToken.nextAuth}`;
      this.isShowSigningCode = true;
    },
    // 已签约完成
    async confirmSigning() {
      const { id, orderId } = this.agreementObj;
      const { data } = await order.getIsCheckAgreement({
        agreementId: id,
        orderId,
        type: 2,
        userId: this.loginUser.userId,
      });
      if (data.status === 1) {
        this.tabIndex = 1;
        this.getData();
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "签约未完成，请重新签约",
          okText: "重新签约",
          cancelText: "取消",
          onOk: () => {
            this.isShowSigningCode = true;
          },
        });
      }
    },
    // 查看签约协议
    async checkSigning({ id }) {
      // 获取协议详情
      const { data } = await user.getAgreementDetail({
        agreementRecordId: id,
        userId: this.loginUser.userId,
      });
      this.signingDetail = data;
      // 获取协议图片
      const { data: img64 } = await user.getAgreementImg({ id });
      this.imgBase64 = 'data:image\/\w+;base64,' + img64;
      // 打开预览弹窗
      this.isShowSigningDetail = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
.order-list {
  padding: 30px;
  li {
    border-bottom: 1px solid #ddd;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
  .order-no {
    font-weight: bold;
    font-size: 16px;
    padding-bottom: 30px;
  }
  .order-item {
    display: flex;
    // align-items: center;
    .order-img {
      width: 280px;
      height: 160px;
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 280px;
      }
    }
    .order-info {
      flex: 1;
      margin-left: 20px;
      .name {
        font-size: 16px;
        height: 60px;
        line-height: 30px;
      }
      .time {
        font-size: 15px;
        color: #666;
      }
      .money {
        margin-top: 30px;
        color: #fa4418;
        span {
          &:last-child {
            font-size: 24px;
          }
        }
      }
    }
    .order-extend {
      flex: 1;
      margin-left: 20px;
      line-height: 26px;
      .time {
        font-size: 15px;
        color: #666;
      }
      .send {
        min-height: 26px;
      }
    }
    .order-action {
      width: 100px;
      &.extend {
        width: 130px;
      }
      .pay-list {
        a {
          display: block;
          margin: 2px auto;
          padding: 5px 15px;
          &:hover {
            background: #f5f5f5;
          }
        }
      }
      .order-del {
        margin-top: 20px;
        text-align: left;
        width: 100%;
        /deep/.ivu-poptip-rel {
          width: 100px;
        }
        /deep/.ivu-poptip-popper {
          width: 220px;
        }
      }
    }
  }
}
</style>
